<template>
  <div
    class="bg-card border border-muted-card rounded-lg px-2 py-3 min-w-0 w-full sm:w-[15rem] cursor-pointer"
    @click="emit('click')"
  >
    <div class="flex items-center gap-2 min-w-0">
      <span class="heading-3 font-semibold truncate">{{ tab.code }}</span>
      <span class="body-4 opacity-70 text-muted-foreground truncate">
        {{ tab.name }}
      </span>
    </div>
    <div class="flex items-center gap-3 mt-1 body-4 text-muted-foreground">
      <span v-if="seatCount > 0" class="flex items-center gap-1">
        <l-icon name="lucide/users" size="small" />
        <span class="text-n-0">{{ seatCount }}</span>
      </span>
      <span v-if="elapsedTime" class="flex items-center gap-1">
        <l-icon name="lucide/clock" size="small" />
        <span class="text-n-0">{{ elapsedTime }}</span>
      </span>
      <span class="flex items-center gap-1">
        <l-icon :name="lucideCurrencyIcon" size="small" />
        <span class="text-n-0">{{ formattedTotal }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useNow } from '@vueuse/core'
import { differenceInMinutes } from 'date-fns'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { LIcon } from '@last/core-ui/paprika'

import { useMoney } from '@/composables/useMoney'
import { useTabs } from '@/composables/useTabs'
import { useConfigStore } from '@/store/config'

const props = defineProps<{
  tabId: string
}>()

const emit = defineEmits<{
  click: []
}>()

const { tab, total, lastInteraction } = useTabs(() => props.tabId)
const { formatNumber } = useMoney()
const configStore = useConfigStore()

const { lucideCurrencyIcon } = storeToRefs(configStore)
const now = useNow({ interval: 60 * 1000 })

const seatCount = computed(() => tab.value.seats.length)

const elapsedTime = computed(() => {
  if (!lastInteraction.value) return undefined
  const minutes = Math.floor(Math.max(differenceInMinutes(now.value, lastInteraction.value), 0))
  const roundMinutes = `${minutes % 60}`.padStart(2, '0')
  return `${Math.floor(minutes / 60)}:${roundMinutes}`
})

const formattedTotal = computed(() => {
  return formatNumber(total.value ?? 0)
})
</script>
